module.exports = __webpack_public_path__ + "img/medal.4cd5e3b3.svg";